<template lang="html">
  <!-- <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" /> -->
  <div class="bg-white p-5 rounded">
    Door het verstrekken van uw informatie accepteert u ons privacybeleid. Voor
    meer details kunt u
    <a
      href="https://www.scania.com/nl/nl/home/admin/misc/verklaring.html"
      target="_blank"
      >ons privacybeleid</a
    >
    bezoeken
  </div>
  <div class="d-grid gap-2 pb-3">
    <button
      type="button"
      class="btn btn-secondary btn-lg mt-4"
      @click="saveQuestionGdpr()"
    >
      <span>Akkoord</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionGdprScreen",
  data: () => ({}),
  computed: {},
  methods: {
    addRemoveAnswer(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        this.checkedAnswers.splice(this.checkedAnswers.indexOf(answer), 1);
      } else {
        this.checkedAnswers.push(answer);
      }
    },
    answerChecked(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        return true;
      }
      return false;
    },
    saveQuestionGdpr() {
      let code = this.createCode(5);
      this.$store.commit("setCode", code);
      this.$store.commit("setQuestionGdpr", "true");
      let data = {};
      data.name = this.$store.getters.getFirstName;
      data.last_name = this.$store.getters.getLastName;
      data.phone = this.$store.getters.getPhone;
      data.age = "nvt";
      data.email = this.$store.getters.getEmail;
      data.company = this.$store.getters.getCompany || "";
      data.job_position = this.$store.getters.getJobposition;
      // Convert boolean question_one to "ja"/"nee"
      const questionOneValue = this.$store.getters.getQuestionOne;
      data.question_one =
        questionOneValue === true
          ? "ja"
          : questionOneValue === false
          ? "nee"
          : "";
      data.code = code;
      this.$store.dispatch("saveVisitor", data);
    },
    createCode(length) {
      let result = "";
      const characters = "0123456789";
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
        counter += 1;
      }
      return result.toString();
    },
  },
};
</script>

<style lang="css" scoped>
h2 {
  font-size: 40px;
  color: #000 !important;
}
.bg-field {
  color: #fdf7ea !important;
}
a {
  color: #000 !important;
}
</style>
